import React from "react";
import { Shield, Flame, Heart } from "lucide-react";

const VALUES = [
    {
        icon: Shield,
        title: "For The Line",
        text: "Built for law enforcement, military, fire, and EMS. We honor the watch you keep.",
    },
    {
        icon: Flame,
        title: "Roasted to Order",
        text: "Crafted with discipline and roasted to order. No shortcuts. No compromises.",
    },
    {
        icon: Heart,
        title: "Mission Driven",
        text: "A portion of every order goes to support first-responder family relief funds.",
    },
];

const Mission = () => {
    return (
        <section
            id="mission"
            data-testid="mission-section"
            className="relative py-24 md:py-32 bg-[#0B0E14] bs-grain overflow-hidden"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
                    {/* Left — text */}
                    <div>
                        <div className="bs-eyebrow">Our Mission</div>
                        <div className="bs-stencil-divider my-8 max-w-xs" />
                        <p
                            data-testid="mission-paragraph-1"
                            className="font-body text-base md:text-lg text-slate-300 leading-relaxed"
                        >
                            Badge & Shield Coffee Company was founded on a
                            simple principle: the men and women who serve our
                            communities deserve more than a thank-you — they
                            deserve a brand that stands behind them.
                        </p>
                        <p
                            data-testid="mission-paragraph-2"
                            className="font-body text-base md:text-lg text-slate-300 leading-relaxed mt-4"
                        >
                            Rooted in Louisville, Kentucky, we craft
                            exceptional coffee that honors courage,
                            strengthens community, and reflects the values
                            we live by: Duty. Honor. Coffee.
                        </p>

                        <div className="grid grid-cols-2 gap-4 mt-10">
                            {VALUES.map(({ icon: Icon, title, text }) => (
                                <div
                                    key={title}
                                    data-testid={`value-card-${title.toLowerCase().replace(/\s+/g, "-")}`}
                                    className="bs-card p-5"
                                >
                                    <Icon className="w-6 h-6 text-[#004466] mb-3" />
                                    <div className="font-anton text-xl uppercase tracking-wide text-white mb-1">
                                        {title}
                                    </div>
                                    <p className="font-body text-xs md:text-sm text-slate-400 leading-relaxed">
                                        {text}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right — 2×2 image collage */}
                    <div className="relative h-[600px] hidden lg:block">
                        <div className="absolute inset-0 grid grid-cols-2 grid-rows-2 gap-4">
                            <div className="overflow-hidden border border-[#1E293B]">
                                <img
                                    src="https://images.pexels.com/photos/3023654/pexels-photo-3023654.jpeg?auto=compress&cs=tinysrgb&w=900"
                                    alt="Police officer in uniform standing on city street"
                                    className="w-full h-full object-cover"
                                />
                            </div>
                            <div className="overflow-hidden border border-[#1E293B]">
                                <img
                                    src="https://images.pexels.com/photos/7714736/pexels-photo-7714736.jpeg?auto=compress&cs=tinysrgb&w=900"
                                    alt="Two police officers in uniform on patrol"
                                    className="w-full h-full object-cover"
                                />
                            </div>
                            <div className="overflow-hidden border border-[#1E293B]">
                                <img
                                    src="https://images.pexels.com/photos/9862225/pexels-photo-9862225.jpeg?auto=compress&cs=tinysrgb&w=900"
                                    alt="Police officer walking down a city street"
                                    className="w-full h-full object-cover"
                                />
                            </div>
                            <div className="overflow-hidden border border-[#1E293B]">
                                <img
                                    src="https://images.pexels.com/photos/7714968/pexels-photo-7714968.jpeg?auto=compress&cs=tinysrgb&w=900"
                                    alt="Female police officer in uniform on duty"
                                    className="w-full h-full object-cover"
                                />
                            </div>
                        </div>
                        <div className="absolute -bottom-4 -left-4 bg-[#004466] px-6 py-4 z-10">
                            <div className="font-anton text-xl uppercase tracking-wider text-white">
                                EST. KENTUCKY
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Mission;
